const NIRA_URL =
  'https://gui.cloud.niradynamics.se/api2018/tiles/vector/aggregated/maintenance-aggregation/{z}/{x}/{y}?access_token=';
const NIRA_ACCESS_TOKEN = '75ceb126-4141-4030-935b-47b4d5218aec';

export { NIRA_ACCESS_TOKEN, NIRA_URL };
